<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Previous Payroll Software Provider</h1>
    <p>To allow us to ensure that we can a seemless transition to our payroll services, please provide the name of {{ formData.clientName }}'s previous payroll software provider.</p>
  </div>

  <div class="cell small-5">
    <form class="fieldset" @submit.prevent>
      <label>Previous Software Provider</label>
      <AutoSuggest
        :suggestions="knownPayrollProviders"
        name="previousPayrollSoftwareProvider"
        v-model="formData.previousPayrollSoftwareProvider"
        regexPattern="[A-Za-z0-9' ]*"
      />
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AutoSuggest from '@/components/controls/AutoSuggest.vue'
import knownPayrollProviders from '@/helpers/arrays/knownPayrollProviders'

const error = ref([])

const props = defineProps({
  formData: Object
})

const validateStep = () => {
  error.value = []

  const value = String(props.formData?.previousPayrollSoftwareProvider ?? '').trim()
  if (!value) {
    error.value.push('Please enter a previous software provider.')
  }

  return error.value.length === 0
}

const executeStep = async () => true

onMounted(() => {})

defineExpose({ validateStep, executeStep })
</script>
